<template>

  <div>

    <v-row class="mt-2">
      <v-col class="text-center" cols="12">

        <h3>Информация о торговой организации
          <font-awesome-icon v-if="selectedItem && selectedItem.id && !disabled" @click="onSubmit()" icon="edit" role="button" style="font-size: 22px; color: seagreen;" class="ml-3 edit_icon"/>
        </h3>

      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="12" class="pt-0">
        <v-autocomplete
            v-model="selectedItem"
            :items="items"
            :search-input.sync="searchOrganization"
            return-object
            hide-details
            item-text="name"
            item-value="id"
            label="Торговая организация"
            no-filter
            clearable
            class="plcolor"
            hide-selected
            no-data-text="Нет организаций, создайте новую"
            :disabled="disabled"
            :rules="[rules.required]"
            @change="select"
        >
          <template v-slot:append-item>
            <v-btn
                block
                type="submit"
                class="mt-1"
                @click.prevent="addNewOrganization">
              Добавить новую организацию
            </v-btn>
          </template>
          
        </v-autocomplete>
      </v-col>
      <v-col v-if="selectedItem" cols="12" class="mt-2">
        <v-text-field
            type="text"
            label="Адрес"
            id="address"
            v-model="selectedItem.address"
            disabled
        ></v-text-field>
      </v-col>
    </v-row>

    <v-dialog  width="500" v-if="showDialog" v-model="showDialog">
      <v-card>
        <v-card-title class="headline primary">
          {{ this.editItem.id ? 'Редактрирование ' : 'Добавление ' }} Торговой организации
        </v-card-title>
        <v-card-text>

          <v-row>
            <v-col cols="12" class="mt-2">
              <v-text-field
                v-model="editItem.name"
                label="Название"
              ></v-text-field>
            </v-col>
          </v-row>

          <div class="v-input v-text-field theme--light">
            <div class="v-input__control">
              <div class="v-input__slot">
                <div class="v-text-field__slot">
                  <label aria-hidden="true" class="v-label v-label--active theme--light"
                         style="left: 0px; right: auto; position: absolute;">Адрес</label>

                  <el-autocomplete
                    v-model="editItem.address"
                    :fetch-suggestions="AutocompleteSearchAddress"
                    placeholder="Москва, Тверской б-р, д 9"
                    :trigger-on-focus="false"
                    id="trade-organization-address"
                  ></el-autocomplete>
                </div>
              </div>
              <div class="v-text-field__details">
                <div class="v-messages theme--light">
                  <div class="v-messages__wrapper"></div>
                </div>
              </div>
            </div>
          </div>

        </v-card-text>
        <v-divider>

        </v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="sendForm">Сохранить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>

</template>

<script>
import axios from 'axios';

export default {
  name: 'TradeOrganization',
  props: {
    existSelectedItem: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    items: [],
    suggestions: [],
    editItem: {
      address: '',
      id: '',
      name: '',
    },
    selectedItem: {
      id: '',
      address: '',
      name: '',
    },
    searchOrganization: '',
    rules: {
      required: v => !!v || 'Поле должно быть заполнено',
    },
    showDialog: false,
  }),
  mounted() {
    if (this.existSelectedItem) {
      this.selectedItem = this.existSelectedItem;
      this.items.push(this.selectedItem);
    }
  },
  watch: {
    searchOrganization() {
      const app = this;
      app.isLoading = true;

      if (!this.searchOrganization) {
        app.items = [];
        return;
      }

      app.$store.getters.ax.post('sales/api/trade-organization', { name: this.searchOrganization })
        .then((response) => {
          app.items = response.data?.trade_organizations || [];
        }).catch((error) => {
          app.$store.dispatch('HandleError', error);
        })
        .finally(() => {
          app.isLoading = false;
        });
    },
  },
  methods: {
    addNewOrganization() {
      this.editItem = {
        id: '',
        address: '',
        name: '',
      };
      this.showDialog = true;
    },
    onSubmit() {
      this.editItem = this.selectedItem;
      this.showDialog = true;
    },
    clearForm() {
      this.editItem = {
        id: '',
        address: '',
        name: '',
      };
      this.showDialog = false;
    },
    sendForm() {
      const app = this;
      const urlMethod = app.editItem.id ? 'update' : 'create';

      const item = app.editItem;

      return app.$store.getters.ax.post(`sales/api/trade-organization/${urlMethod}`, item)
        .then((response) => {
          this.items = [response.data.trade_organization, ...this.items];
          this.selectedItem = response.data.trade_organization;
          this.select();
          this.clearForm();
        }).catch((error) => {
          app.$store.dispatch('HandleError', error);
        })
        .finally(() => {
          app.isLoading = false;
        });
    },
    select() {
      console.log('sdkljdsfkldf');
      this.$emit('select', this.selectedItem);
    },
    AutocompleteSearchAddress(queryString, cb) {
      if (!queryString) return;
      const app = this;
      const info = { count: 20, query: queryString };
      const config = {
        headers: {
          Accept: 'application/json, text/javascript, */*; q=0.01',
          Authorization: 'Token 7a77efb8ab6dae6e380c7e438b85360185660f34',
          'Content-Type': 'application/json',
        },
      };

      axios.post('https://dadata.ru/api/v2/suggest/address', info, config)
        .then((res) => {
          app.suggestions = res.data.suggestions;
          cb(app.suggestions);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss">

  .el-autocomplete {
    width: 100%;

    .el-input__inner {
      border: none;
    }
  }

  .edit_icon:hover {
    opacity: 0.7;
  }

</style>
